export const TAXONOMY_PAYMENT_METHOD = "/api/questionnaire/v1/taxonomy/payment-method";
export const TAXONOMY_PAYMENT_METHOD_PF2 = "/api/questionnaire/v1/taxonomy/payment-method-pf2";
export const EDUCATIONAL_PLATFORM = "/api/questionnaire/v1/taxonomy/educational-platform";
export const TAXONOMY_PRODUCT_TYPE = "/api/questionnaire/v1/taxonomy/product-type";
export const CLIENT_FROM_ORIGINS = "/api/questionnaire/v1/taxonomy/client-from-origins";
export const TAXONOMY_STEP_FEEDBACK_OPTIONS = "/api/questionnaire/v1/taxonomy/step-feedback-options";
export const SEGMENTS = "/api/questionnaire/v1/taxonomy/segments";

export const PERSONAL_DATA_BY_INN = "/api/questionnaire/v1/personal-data/by-inn";